import { HttpHeaders } from '@angular/common/http';

export const HttpHeaderJson = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}